import { ChangeEvent, useState } from "react";
import ICategory from "../../../../models/ICategory";
import "./OrderCategoryRow.scss";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import { ConfirmDeleteOverlayFn } from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../../shared/OwAcceptCancelActions/OwAcceptCancelActions";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { OwLabel } from "@components/shared/OwLabel/OwLabel";

type Props = {
    category: ICategory;
    index: number;
    updateCategoryFn: (category: ICategory) => void;
    deleteCategoryFn: (category: ICategory) => void;
};

export const OrderCategoryRow = (props: Props) => {
    const [editMode, setEditMode] = useState(false);
    const [category, setCategory] = useState(props.category);
    const [deleteElem, setDeleteElem] = useState<string | null>(null);

    const deleteCategory = () => {
        setDeleteElem(`category-${props.index}`);
    };

    const commitDelete = () => {
        props.deleteCategoryFn(props.category);
    };

    const cancelDelete = () => {
        setDeleteElem(null);
    };

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const updateCategory = () => {
        props.updateCategoryFn(category);

        toggleEditMode();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const _category = { ...category };

        // @ts-expect-error
        _category[name] = value;

        setCategory(_category);
    };

    return (
        <div className={"OrderCategoryRow position-relative"} id={`parent-category-${props.index}`}>
            <ConfirmDeleteOverlayFn
                targetElem={deleteElem}
                message={"confirm_delete"}
                handleConfirm={commitDelete}
                handleCancel={cancelDelete}
                skipMainView={true}
                nestedParentElem={`parent-category-${props.index}`}
            />

            <div className={"position-relative py-2"} id={`category-${props.index}`}>
                {editMode ? (
                    <div className={"d-flex"}>
                        <div className={"me-2"}>
                            <OwAcceptCancelActions
                                isEditMode={!editMode}
                                onAcceptClickFn={updateCategory}
                                onCancelClickFn={toggleEditMode}
                            />
                        </div>
                        <div>
                            <OwInputWrapper name={"name"} fn={handleChange} value={category.name} />
                        </div>
                        <div className={"ms-2"}>
                            <OwToggle
                                fn={handleChange}
                                name={"hide_category"}
                                label={"hide_category"}
                                active={!!category.hide_category}
                                labelOnRight={true}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={"d-flex align-items-center"}>
                        <span className={"me-2"}>
                            <OwDeleteEditActions isEditMode={editMode} onTrashClickFn={deleteCategory} onEditClickFn={toggleEditMode} />
                        </span>
                        {props.category.name}
                        {props.category.hide_category ? (
                            <OwLabel className={"ms-2 text-muted"} title={"hidden"} leftIconClass={"fas fa-eye-slash"} />
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
};
